<style>
	.line-box {
		display: flex; flex-direction: row; height: 60px; align-items: center;
		
	}
	.line-name {
		width: 130px; text-align: right; padding-right: 10px;
	}
	.line-tag-box {
		display: flex; flex-direction: row;  align-items: center;
	}
	.line-tag {
		width: 700px;  background-color: #f2dede; color: #b94a48; line-height: 20px; padding: 10px; border-radius: 3px;
	}
	
	.upload-box {
		display: flex;
		flex-direction: row;
		align-items: flex-start;
		margin-bottom: 10px;
		margin-top: 10px;
	}
	.upload-content {
		width: 720px;
	}
	.avatar-uploader .el-upload {
	    border-radius: 6px;
	    cursor: pointer;
	    position: relative;
	    overflow: hidden;
	  }
	  .avatar-uploader .el-upload:hover {
	    border-color: #409EFF;
	  }
	  .avatar-uploader-icon {
	    font-size: 28px;
	    color: #8c939d;
	    width: 80px;
	    height: 80px;
	    line-height: 80px;
	    text-align: center;
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
	  }
	  .avatar {
		  border: 1px dashed #d9d9d9;
	    width: 80px;
	    height: 80px;
	    display: block;
		object-fit: cover;
		border-radius: 6px;
	  }
	  .upload-list {
		display: flex;
		flex-wrap: wrap;
		align-items: flex-start;
		gap: 10px;
	  }
	  .upload-card {
		position: relative;
		width: 80px;
		height: 80px;
	  }
	  .upload-remove {
		position: absolute;
		top: -8px;
		right: -8px;
		width: 20px;
		height: 20px;
		border: none;
		border-radius: 50%;
		background: #f56c6c;
		color: #fff;
		line-height: 20px;
		text-align: center;
		cursor: pointer;
		padding: 0;
		z-index: 2;
	  }
	  .upload-remove:hover {
		background: #dd3f3f;
	  }
</style>

<template>
	<div>
		<div class="line-box">
			<div class="line-name">输出类型：</div>
			<el-select style="width: 720px;" placeholder="请选择输出类型" v-model="form.ads_type">
				<el-option :key="0" label="自行编辑" :value="0">自行编辑</el-option>
				<el-option :key="1" label="轮询图片" :value="1">轮询图片</el-option>
				<el-option :key="2" label="图片广告" :value="2">图片广告</el-option>
			</el-select>
		</div>
		<div class="line-tag-box">
			<div class="line-name"></div>
			<div class="line-tag">提醒： 显示在设置中，输出版本。</div>
		</div>
		
		<div class="line-box">
			<div class="line-name">类型索引：</div>
			<el-input type="text" style="width: 720px;" placeholder="请填写类型索引" v-model="form.ads_index"></el-input>
		</div>
		<div class="line-tag-box">
			<div class="line-name"></div>
			<div class="line-tag">提醒： 代码中硬编码索引，具体值询问技术。</div>
		</div>
		
		
		<div class="line-box">
			<div class="line-name">输出版本：</div>
			<el-input type="text" style="width: 720px;" placeholder="请填写输出版本" v-model="form.ads_name"></el-input>
		</div>
		<div class="line-tag-box">
			<div class="line-name"></div>
			<div class="line-tag">提醒： 显示在设置中的输出版本</div>
		</div>
		
		<div class="upload-box">
			<div class="line-name">上传示例图：</div>
			<div class="upload-content">
				<div v-if="form.exam_img_url" class="upload-list">
					<div class="upload-card">
						<img :src="form.exam_img_fullurl" class="avatar">
						<button type="button" class="upload-remove" @click.stop.prevent="removeExampleImg">×</button>
					</div>
				</div>
				<el-upload class="avatar-uploader" :action="this.$http_url + '/Upload/UploadImage'" :headers="headers" :show-file-list="false" 
					:on-success="UploadSuccess1"
					:before-upload="beforeUpload"
					:on-error="UploadError"
					v-else
				>
				  <i class="el-icon-plus avatar-uploader-icon"></i>
				</el-upload>
			</div>
		</div>
		<div class="line-tag-box">
			<div class="line-name"></div>
			<div class="line-tag">提醒： 显示在广告名称后面，点击小图标预览</div>
		</div>
		<div class="upload-box" v-if="form.ads_type == 1">
			<div class="line-name">上传轮询图：</div>
			<div class="upload-content">
				<div class="upload-list">
					<div class="upload-card" v-for="(items, indexs) in image_ids" :key="items.img_url + indexs">
						<img :src="items.img_full_url" class="avatar">
						<button type="button" class="upload-remove" @click.stop.prevent="removePollingImg(indexs)">×</button>
					</div>
				<el-upload class="avatar-uploader" :action="this.$http_url + '/Upload/UploadImage'" :headers="headers" :show-file-list="false" 
					:on-success="UploadSuccess2"
					:before-upload="beforeUpload"
					:on-error="UploadError"
				>
					<i class="el-icon-plus avatar-uploader-icon"></i>
				</el-upload>
				</div>
			</div>
		</div>
		<div class="line-tag-box" v-if="form.ads_type == 1">
			<div class="line-name"></div>
			<div class="line-tag">提醒： 可添加多张广告图进行轮询</div>
		</div>
		<div class="line-box">
			<div class="line-name">排序：</div>
			<el-input type="number" style="width: 720px;" placeholder="从小到大" v-model="form.sorts"></el-input>
		</div>
		<div class="line-tag-box">
			<div class="line-name"></div>
			<div class="line-tag">提醒： 从小到大排序 0-10</div>
		</div>
		
		<div style="width: 100%; margin-top: 20px;">
			<el-button style="width: 100%;" type="primary" @click="addProduct">{{ isEdit ? '确认编辑' : '确认添加' }}</el-button>
		</div>
	</div>
</template>

<script>
	const defaultForm = function(){
		return {
			game_type:'pl3',
			ads_type:'',
			ads_index:'',
			ads_name:'',
			example_img_id:'',
			image_ids:[],
			sorts:'',
			exam_img_url:'',
			exam_img_fullurl:'',
		};
	};

	export default {
		props:{
			isEdit:{
				type:Boolean,
				default:false
			},
			editData:{
				type:Object,
				default:null
			}
		},
		data(){
			return {
				example_img:null,
				image_ids:[],
				form:defaultForm(),
				headers:{
					Authorization:''
				}
			}
		},
		watch:{
			isEdit(){
				this.initForm();
			},
			editData(){
				this.initForm();
			}
		},
		created() {
			this.headers.Authorization = localStorage.getItem('access_token');
			this.initForm();
		},
		methods: {
			initForm(){
				this.form = defaultForm();
				this.image_ids = [];
				if(!this.isEdit || !this.editData){
					return;
				}
				const examImgUrl = this.editData.exam_img_url || '';
				this.form = Object.assign(defaultForm(), {
					id:this.editData.id,
					ads_type:this.editData.ads_type === '' ? '' : Number(this.editData.ads_type),
					ads_index:this.editData.ads_index,
					ads_name:this.editData.ads_name,
					sorts:this.editData.sorts,
					exam_img_url:this.getImagePath(examImgUrl),
					exam_img_fullurl:this.getImageFullUrl(examImgUrl),
				});
				this.image_ids = this.normalizeImageList(this.editData.image_ids);
			},
			addProduct() {
				console.log("add product", this.form);
				// 验证格式
				if(this.form.ads_type === ""){
					return this.$message({ message: '请选择输出类型', type: 'warning' });
				}
				if(this.form.ads_index == ""){
					return this.$message({ message: '请输入输出索引', type: 'warning' });
				}
				if(this.form.ads_name == ""){
					return this.$message({ message: '请输入类型名称', type: 'warning' });
				}
				if(this.form.sorts == ""){
					return this.$message({ message: '请输入排序', type: 'warning' });
				}
				this.form.image_ids = this.form.ads_type == 1 ? this.image_ids : [];
				// 提交上传
				this.submit();
			},
			submit(){
				let _this = this;
				const url = this.isEdit ? "/TplSet/editAd" : "/TplSet/addTplAds";
				const loading = this.$loading({
						lock: true,
						text: this.isEdit ? '编辑中' : '添加中',
						spinner: 'el-icon-loading',
						background: 'rgba(0, 0, 0, 0.7)'
					});
				_this.$api.post(url, this.form).then(res=>{
					loading.close();
					if(res.code == 1)
					{
						_this.$message({
							 message: this.isEdit ? '编辑成功~' : '添加成功~',
							 type: 'success',
						});
						_this.$emit('success');
					}else{
						return _this.$message({
							 message: res.msg,
							 type: 'warning',
						});
					}
				}).catch(err=>{
					loading.close();
				});
			},
			beforeUpload(file){
			},
			UploadSuccess1(res, file, fileList){
				if(res.code == 200)
				{
					this.form.exam_img_url = res.file_path;
					this.form.exam_img_fullurl = this.$http_host + res.file_path;
				}else{
					return this.$message({ message: res.msg, type: 'warning' });
				}
			},
			UploadSuccess2(res, file, fileList){
				if(res.code == 200)
				{
					this.image_ids.push({img_url: res.file_path, img_full_url: this.$http_host + res.file_path});
				}else{
					return this.$message({ message: res.msg, type: 'warning' });
				}
			},
			removeExampleImg(){
				this.form.exam_img_url = '';
				this.form.exam_img_fullurl = '';
				this.form.example_img_id = '';
			},
			removePollingImg(index){
				this.image_ids.splice(index, 1);
			},
			normalizeImageList(list){
				if(!Array.isArray(list)){
					return [];
				}
				return list.map(item=>{
					const imgUrl = typeof item == 'string' ? item : (item.img_url || item.img_full_url || '');
					return {
						img_url:this.getImagePath(imgUrl),
						img_full_url:this.getImageFullUrl(imgUrl)
					};
				}).filter(item=>item.img_url);
			},
			getImagePath(url){
				if(!url){
					return '';
				}
				if(this.$http_host && url.indexOf(this.$http_host) === 0){
					return url.replace(this.$http_host, '');
				}
				return url;
			},
			getImageFullUrl(url){
				if(!url){
					return '';
				}
				if(/^https?:\/\//.test(url)){
					return url;
				}
				return this.$http_host + url;
			},
			UploadError(){
				return this.$message({ message: '上传失败，请重试', type: 'warning' });
			}
		},
	}
</script>
